import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import Packages from "layouts/packages";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import NewPackages from "layouts/newPackage";

// @mui icons
import Icon from "@mui/material/Icon";
import Branches from "layouts/branches";
import Configurations from "layouts/configurations";
import WhatsappScreen from "layouts/whatsapp";
import Customers from "layouts/customers";
import Campaigns from "layouts/campaigns";
import PricingTemplates from "layouts/pricing_templates";
import PricingLists from "layouts/pricing_lists";
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import PricingCalculator from "layouts/calculator";
import Employees from "layouts/employees";
import Forecast from "layouts/forecast";
import InternalTracking from "layouts/internalTracking";
import ItemMaster from "layouts/itemMaster";
import VendorApis from "layouts/vendorApis";
import Activity from "layouts/activity";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "hidden",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <Tables />,
  },
  {
    type: "hidden",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Billing />,
  },
  {
    type: "collapse",
    name: "Packages",
    key: "packages",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/packages",
    component: <Packages />,
  },
  {
    type: "collapse",
    name: "New",
    key: "new",
    icon: <Icon fontSize="small">add</Icon>,
    route: "/new",
    component: <NewPackages />,
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/customers",
    component: <Customers />,
  },
  {
    type: "collapse",
    name: "Branches",
    key: "branches",
    icon: <Icon fontSize="small">account_tree</Icon>,
    route: "/branches",
    component: <Branches />,
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "configurations",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/configurations",
    component: <Configurations />,
  },
  {
    type: "collapse",
    name: "Employees",
    key: "employees",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/employees",
    component: <Employees />,
  },
  {
    type: "collapse",
    name: "Communications",
    key: "communications",
    icon: <Icon fontSize="small">message</Icon>,
    route: "/communications",
    component: <WhatsappScreen />,
  },
  {
    type: "collapse",
    name: "Campaigns",
    key: "campaigns",
    icon: <Icon fontSize="small">campaign</Icon>,
    route: "/campaigns",
    component: <Campaigns />,
  },
  {
    type: "collapse",
    name: "Pricing Templates",
    key: "pricings",
    icon: <Icon fontSize="small">percent</Icon>,
    route: "/pricings",
    component: <PricingTemplates />,
  },
  {
    type: "collapse",
    name: "Price Lists",
    key: "pricelist",
    icon: <PriceChangeIcon fontSize="small" color="primary" />,
    route: "/pricelist",
    component: <PricingLists />,
  },
  {
    type: "collapse",
    name: "Calculator",
    key: "calculator",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/calculator",
    component: <PricingCalculator />,
  },
  {
    type: "collapse",
    name: "Forecast",
    key: "forecast",
    icon: <Icon fontSize="small">insights</Icon>,
    route: "/forecast",
    component: <Forecast />,
  },
  {
    type: "collapse",
    name: "Internal Tracking",
    key: "internal-tracking",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    route: "/internal-tracking",
    component: <InternalTracking />,
  },
  {
    type: "collapse",
    name: "Item Names",
    key: "item-names",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/item-names",
    component: <ItemMaster />,
  },
  {
    type: "collapse",
    name: "Vendor APIs",
    key: "vendor-apis",
    icon: <Icon fontSize="small">api</Icon>,
    route: "/vendor-apis",
    component: <VendorApis />,
  },
  {
    type: "collapse",
    name: "Activity",
    key: "activity",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/activity",
    component: <Activity />,
  },
  {
    type: "hidden",
    name: "RTL",
    key: "rtl",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/rtl",
    component: <RTL />,
  },
  {
    type: "hidden",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "hidden",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
  {
    type: "hidden",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "hidden",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
];

export const un_auth_routes = [
  {
    type: "hidden",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "hidden",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
]

export const manager_routes = [
  {
    type: "collapse",
    name: "Packages",
    key: "packages",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/packages",
    component: <Packages />,
  },
  {
    type: "collapse",
    name: "New",
    key: "new",
    icon: <Icon fontSize="small">add</Icon>,
    route: "/new",
    component: <NewPackages />,
  },
  {
    type: "collapse",
    name: "Calculator",
    key: "calculator",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/calculator",
    component: <PricingCalculator />,
  },
]

export default routes;
